import { initIdList } from '@/lib/sort';

export const initChildrenSort = (goal, rids) => {
  const initVal = initIdList(goal.childrenSort.map(({ uid }) => (uid)), goal.children.map((c) => c.uid));
  return initVal.filter((id) => rids[id] !== undefined).map((id) => ({ rid: rids[id] }));
};
